var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgL08 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.00 0.00 252.00 455.00",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(-2533.00, 0.00)",
    id: "L8_Copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2771.47,105.68 C2769.58,101.33 2760.74,87.45 2757.58,84.24 C2755.11,81.77 2747.99,77.17 2743.48,75.14 C2736.50,72.02 2722.33,68.58 2714.47,67.18 C2707.15,66.03 2690.98,64.08 2682.14,63.28 C2673.19,62.63 2656.14,61.90 2648.04,61.82 C2640.22,61.94 2623.68,62.79 2615.81,64.07 C2606.48,65.61 2590.09,70.24 2582.90,73.36 C2575.86,76.45 2563.79,83.75 2558.87,87.90 C2555.67,90.64 2552.23,94.41 2549.82,97.95 C2547.82,100.94 2544.58,107.31 2543.34,110.70 C2541.33,116.34 2538.62,132.94 2537.88,141.86 C2536.99,152.77 2537.22,165.40 2537.36,171.75 C2537.67,178.55 2538.46,192.61 2538.93,199.86 C2539.64,209.08 2542.03,223.11 2544.34,231.38 C2546.67,239.66 2553.63,257.91 2557.11,264.91 C2560.58,271.70 2568.35,285.63 2572.66,292.76 C2577.24,300.00 2587.25,314.80 2592.67,322.37 C2603.97,337.40 2624.55,362.95 2633.28,372.43 C2635.36,374.58 2640.92,380.20 2641.38,380.59 C2645.26,383.80 2653.70,388.96 2657.27,390.32 C2660.88,391.64 2666.59,392.03 2670.04,391.36 C2673.18,390.71 2679.34,388.51 2682.60,386.87 C2686.63,384.82 2690.09,382.47 2694.25,379.08 C2699.33,374.83 2709.35,364.85 2715.75,357.66 C2721.29,351.24 2731.94,338.03 2737.06,331.25 C2739.69,327.70 2749.68,312.02 2753.58,305.57 C2757.39,299.05 2764.88,285.61 2767.83,278.63 C2770.85,271.43 2775.78,255.22 2777.10,248.07 C2778.58,239.68 2780.19,225.06 2780.55,216.79 C2780.86,207.97 2780.15,157.59 2780.06,156.00 C2779.78,150.68 2777.27,126.58 2776.26,121.66 C2774.95,115.42 2771.87,106.62 2771.47,105.68 Z",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 10,
    strokeOpacity: 1,
    strokeLinejoin: "round"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgL08, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/L-08.7fa4d7cb.svg";
export { ForwardRef as ReactComponent };